import styled from 'styled-components';
import { breakpoint } from '../theme/breakpoint';
import { linkStyles } from '../styled/links';
import LinkHandler from '../link-handler';
import { FlexRow, FlexCol } from '../styled/flexgrid';
import { Container } from '../styled/containers';

export const Wrapper = styled.footer`
  flex-direction: column;
  white-space: normal;
  margin-top: ${({ theme, $removeMarginTop }) =>
    $removeMarginTop ? '0' : theme.spacing.large};
  border-top: ${({ theme }) => `1px solid ${theme.palette.border}`};

  ${breakpoint.tablet`
    padding-top: ${({ theme }) => theme.spacing.xlarge};
  `}
`;

export const StyledContainer = styled(Container)`
  > ${FlexRow} {
    flex-wrap: wrap;

    ${breakpoint.desktop`
      flex-wrap: unset;
      width: calc(100% - 48px);
      margin: 0 24px;
    `}
  }
`;

export const Top = styled.div`
  padding: ${({ theme }) => `0 ${theme.spacing.standard}`};

  > ${Container} {
    width: 100%;
    display: flex;
    flex-direction: column;
    padding: 0;

    ${breakpoint.desktop`
      flex-direction: row;
    `}

    > ${FlexRow} > ${FlexCol} {
      &:first-of-type {
        min-width: 100%;

        ${breakpoint.desktop`
          min-width: auto;
        `}
      }

      &:nth-child(2) {
        display: none;

        ${breakpoint.desktop`
          display: flex;
        `}
      }
    }
  }
`;

export const SocialLink = styled.a`
  ${linkStyles};
  svg {
    margin-right: 0;
    color: ${({ theme }) => theme.palette.standardText};
    fill: ${({ theme }) => theme.palette.standardText};
  }

  &:focus,
  &:hover {
    svg {
      color: ${({ theme }) => theme.palette.linkHover};
      fill: ${({ theme }) => theme.palette.linkHover};
    }
  }
`;

export const Social = styled.div`
  display: flex;
  justify-content: space-between;
  max-width: 325px;
  margin: ${({ theme }) => `0 auto ${theme.spacing.medium}`};
  padding: ${({ theme }) => `0 ${theme.spacing.medium}`};

  ${breakpoint.desktop`
    padding: 0;
  `}
`;

export const FooterLinksContainer = styled.nav`
  ${breakpoint.tablet`
    display: flex;
  `}

  ${FlexRow} {
    flex-direction: column;
    ${breakpoint.tablet`
    flex-direction: row;
  `}
  }

  ${FlexCol} {
    ${breakpoint.desktop`
      padding: 0 8px;
    `}
  }
`;

export const FooterLinksHeader = styled.h2`
  font-size: ${({ theme }) => theme.fontsize.h4};
  border-bottom: ${({ theme }) => `1px solid ${theme.palette.border}`};
  padding-bottom: ${({ theme }) => theme.spacing.standard};
  margin-top: ${({ theme }) => theme.spacing.standard};
  margin-bottom: 0;
  ${breakpoint.tablet`
  margin-top: 0;
    border-bottom-style: none;
  `};
`;

export const FooterLinks = styled.ul`
  display: flex;
  flex-direction: column;
  width: 100%;
  list-style: none;
  margin: 0;
  padding: 0;

  ${breakpoint.tablet`
  padding-right: ${({ theme }) => `${theme.spacing.small}`};
`}
`;

export const ItemLink = styled(LinkHandler)`
  display: block;
  font-size: ${({ theme }) => theme.fontsize.small};
  color: ${({ theme }) => theme.palette.standardText};
  text-decoration: none;
  padding: ${({ theme }) => theme.spacing.small} 0;

  ${breakpoint.tablet`
    padding: 0;
  `}

  &:focus,
  &:hover {
    color: ${({ theme }) => theme.palette.standardText};
    text-decoration: underline;
  }
`;

export const Item = styled.li`
  margin-bottom: 0;
  margin-left: ${({ theme }) => theme.spacing.standard};
  padding-left: ${({ theme }) => theme.spacing.tiny};
  border-bottom: ${({ theme }) => `1px solid ${theme.palette.border}`};

  ${breakpoint.tablet`
    border-bottom-style: none;
    margin-left: 0;
    padding-left: 0;

    &:not(:last-of-type) {
      margin-bottom: ${({ theme }) => theme.spacing.small};
    }
  `}
`;

export const Bottom = styled.div`
  padding: ${({ theme }) =>
    `${theme.spacing.medium} ${theme.spacing.standard} ${theme.spacing.xlarge}`};
`;

export const BottomInner = styled.div`
  position: relative;
  border-top: ${({ theme }) => `1px solid ${theme.palette.border}`};
  padding-top: ${({ theme }) => theme.spacing.medium};
`;

export const ContentWrapper = styled.div`
  width: 100%;
  text-align: left;

  ${breakpoint.tablet`
    text-align: center;
  `}
`;

export const Text = styled.div`
  font-size: ${({ theme }) => theme.fontsize.small};
  white-space: pre-wrap;

  p {
    margin-bottom: 0;
  }
`;

export const FooterCallout = styled.div`
  margin: 0 auto;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: ${({ theme }) => theme.spacing.medium};

  ${breakpoint.desktop`
    justify-content: flex-start;
  `}
`;

export const FooterCalloutIdent = styled.img`
  width: 127px;
  margin-bottom: 3px;

  ${breakpoint.desktop`
    justify-content: flex-start;
  `}
`;

export const FooterCalloutText = styled.h2`
  text-align: center;
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  text-transform: uppercase;
  line-height: 1;
  margin-top: 0;
  margin-bottom: 0;
  width: 100%;
  max-width: 6em;
`;

export const FooterCalloutSeparator = styled.div`
  background: ${({ theme }) => theme.palette.border};
  height: 155px;
  width: 1px;
  margin: 1em auto;
`;
